import { GTP_BET_BUILDER_COMBINATION_TYPE } from '~Betslip/uiModes/shared/GTPBetBuilder/constants';

export const sldReconnectPayloadFormatter = (type, data) => {
    switch (type) {
        case GTP_BET_BUILDER_COMBINATION_TYPE:
            if (!data.length) {

                return false;
            }

            return {
                type,
                action: 'register',
                combinations: data,
            };

        default:
            break;
    }

    return undefined;
};
